import { createFileRoute } from '@tanstack/react-router'
import { WorkflowPage } from '@/features/workflows/ui/workflow-page'
import { TasksNav } from '@/features/workflows/ui/tasks-nav'

export const Route = createFileRoute('/_authenticated/tasks/$workflow-id/')({
	component: WorkflowPageRoute,
})

function WorkflowPageRoute() {
	const params = Route.useParams()
	return (
		<>
			<TasksNav />
			<WorkflowPage workflowId={params['workflow-id']} />
		</>
	)
}
